import request from '../utils/request'

//获取到当前登录信息 home顶部
export function getUser() {
    return request({
        url: '/user/getUser',
        method: 'get'
    })
}

//用户注册  登录页面
export function addUser(data) {
    return request({
        url: '/user/addUser',
        method: 'post',
        data
    })
}
//新增活动
export function addActivity(data) {
    return request({
        url: '/activity/addActivity',
        method: 'post',
        data
    })
}

//查询活动列表
export function getActivityList(data) {
    return request({
        url: '/activity/listActivity',
        method: 'post',
        data
    })
}
//查询活动分数
export function listActivityScore(data) {
    return request({
        url: '/activity/listActivityScore',
        method: 'post',
        data
    })
}
//查询学生活动总分
export function listUserWithScore(data) {
    return request({
        url: '/user/listUserWithScore',
        method: 'post',
        data
    })
}

//查询学生活动分数细则
export function listUserWithScoreDetail(data) {
    return request({
        url: '/user/listUserWithScoreDetail',
        method: 'post',
        data
    })
}
//查询当前用户活动对应文件
export function listCurrentFiles(data) {
    return request({
        url: '/activity/listCurrentFiles',
        method: 'post',
        data
    })
}

//查询其他用户活动对应文件
export function listFiles(data) {
    return request({
        url: '/activity/listFiles',
        method: 'post',
        data
    })
}

//审批活动
export function approveActivity(data) {
    return request({
        url: '/activity/approveActivity',
        method: 'post',
        data
    })
}

//查看当前用户活动列表
export function listCurrentActivity(data) {
    return request({
        url: '/activity/listCurrentActivity',
        method: 'post',
        data
    })
}

//删除当前用户活动
export function deleteActivity(data) {
    return request({
        url: '/activity/deleteActivity',
        method: 'post',
        data
    })
}



//查询用户列表
export function getUserList(data) {
    return request({
        url: '/user/listUser',
        method: 'post',
        data
    })
}
//删除用户
export function deleteUser(data) {
    return request({
        url: '/user/deleteUser',
        method: 'post',
        data
    })
}
//修改当前登录用户信息
export function updateCurrentUser(data) {
    return request({
        url: '/user/updateCurrentUser',
        method: 'post',
        data
    })
}

//修改任意用户信息
export function updateUser(data) {
    return request({
        url: '/user/updateUser',
        method: 'post',
        data
    })
}


//查询当前登录用户角色
export function getCurrentRoles() {
    return request({
        url: '/role/getCurrentRoles',
        method: 'get'
    })
}

//新增角色
export function addRole(data) {
    return request({
        url: '/role/addRole',
        method: 'post',
        data
    })
}

//查看角色列表
export function listRoles(data) {
    return request({
        url: '/role/listRoles',
        method: 'post',
        data
    })
}
//删除角色
export function deleRole(data) {
    return request({
        url: '/role/deleteRole',
        method: 'post',
        data
    })
}



//获取联系党员老师列表
export function listLXLS(data) {
    return request({
        url: '/LXLS/listLXLS',
        method: 'post',
        data
    })
}

//删除联系党员老师
export function deleteLXLS(data) {
    return request({
        url: '/LXLS/deleteLXLS',
        method: 'post',
        data
    })
}
//新增联系党员老师
export function addLXLS(data) {
    return request({
        url: '/LXLS/addLXLS',
        method: 'post',
        data
    })
}

//获取本人的文件列表
export function getShenqingshu() {
    return request({
        url: '/shenqingshu/getShenqingshu',
        method: 'get'
    })
}

//删除本人的文件
export function deleMyShenqingshu(data) {
    return request({
        url: '/shenqingshu/deleteCurrentShenqingshu',
        method: 'post',
        data
    })
}
//下载本人的文件
export function downloadMyShenqingshu(params) {
    return request({
        url: '/shenqingshu/downloadCurrentShenqingshu?fileName='+params,
        method: 'get',
        responseType:'blob'
    })
}


export function getAuthPermissionsOfUser() {
    return request({
        url: '/oauth/user/permissions',
        method: 'get'
    })
}

export function getAttendances(params) {
    return request({
        url: '/attendances',
        method: 'get',
        params
    })
}

export function clockIn(params) {
    return request({
        url: '/attendances',
        method: 'post',
        params
    })
}

export function clockOut(params) {
    return request({
        url: '/attendances',
        method: 'put',
        params
    })
}

export function getAnnouncements(params) {
    return request({
        url: '/announcements',
        method: 'get',
        params
    })
}

export function createAnnouncement(data) {
    return request({
        url: '/announcements',
        method: 'post',
        data
    })
}

export function updateAnnouncement(data) {
    return request({
        url: '/announcements',
        method: 'put',
        data
    })
}

export function deleteAnnouncement(pathVariable) {
    return request({
        url: '/announcements/' + pathVariable,
        method: 'delete'
    })
}

export function getMessages(params) {
    return request({
        url: '/messages',
        method: 'get',
        params
    })
}

export function getFiles(params) {
    return request({
        url: '/files',
        method: 'get',
        params
    })
}

export function uploadFile(data) {
    return request({
        url: '/files',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}

export function downloadFile(pathVariable) {
    return request({
        url: '/files/' + pathVariable,
        method: 'get',
        responseType: 'blob'
    })
}

export function updateFile(data) {
    return request({
        url: '/files',
        method: 'put',
        data
    })
}

export function createFolder(data) {
    return request({
        url: '/files',
        method: 'post',
        data
    })
}

export function deleteFile(pathVariable) {
    return request({
        url: '/files/' + pathVariable,
        method: 'delete',
    })
}

export function getUsers(params) {
    return request({
        url: '/users',
        method: 'get',
        params
    })
}

export function createUser(data) {
    return request({
        url: '/users',
        method: 'post',
        data
    })
}


export function getDepts() {
    return request({
        url: '/depts',
        method: 'get'
    })
}

export function createDept(data) {
    return request({
        url: '/depts',
        method: 'post',
        data
    })
}

export function updateDept(data) {
    return request({
        url: '/depts',
        method: 'put',
        data
    })
}

export function deleteDept(pathVariable) {
    return request({
        url: '/depts/' + pathVariable,
        method: 'delete'
    })
}

export function getRoles() {
    return request({
        url: '/roles',
        method: 'get'
    })
}

export function createRole(data) {
    return request({
        url: '/roles',
        method: 'post',
        data
    })
}

export function updateRole(data) {
    return request({
        url: '/roles',
        method: 'put',
        data
    })
}

export function deleteRole(pathVariable) {
    return request({
        url: '/roles/' + pathVariable,
        method: 'delete'
    })
}

export function getPermissionsOfRole(pathVariable) {
    return request({
        url: '/roles/' + pathVariable + '/permissions',
        method: 'get'
    })
}

export function createPermissionsToRole(pathVariable, data) {
    return request({
        url: '/roles/' + pathVariable + '/permissions',
        method: 'post',
        data
    })
}

export function updatePermissionsOfRole(pathVariable, data) {
    return request({
        url: '/roles/' + pathVariable + '/permissions',
        method: 'put',
        data
    })
}

export function getPermissions(params) {
    return request({
        url: '/permissions',
        method: 'get',
        params
    })
}

export function createPermission(data) {
    return request({
        url: '/permissions',
        method: 'post',
        data
    })
}

export function updatePermission(data) {
    return request({
        url: '/permissions',
        method: 'put',
        data
    })
}

export function deletePermission(pathVariable) {
    return request({
        url: '/permissions/' + pathVariable,
        method: 'delete'
    })
}

export function uploadProfilePicture(data) {
    return request({
        url: '/profile-pictures',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}

export function searchFile(params) {
    return request({
        url: '/searches/files',
        method: 'get',
        params
    })
}